<template>
  <div class="w-full flex flex-col">
    <div class="flex items-center mb-4">
      <a href="../collections" class="text-12px">{{ $t('post_index_collection.collections') }}</a>
       <img src="../../../../images/breadcrumb_arrow.svg" class="inline-block mx-2 w-4 h-4" alt="Breadcrumb Arrow" />
       <span class="text-12px text-grey-5">{{ collection.title }}</span>
    </div>

    <div id="post-item-collection" class="flex-1">
      <template v-if="state.items.length > 0" v-for="post in state.items" :key="post.id">
        <post-item :post="post" :list-name="'creator_collection:' + collection.id"></post-item>
      </template>
      <div v-else-if="state.loading" class="text-center post-item-loading">
        <img src="../../../../images/icons/loading.png" class="w-6 h-6 ml-2 icon loading-icon"/>
      </div>
    </div>
    <div v-if="shouldShowNoMoreData" class="text-center text-14px text-grey-3">
        {{ $t('home_post_collection.no_more_data') }}
    </div>
  </div>
</template>

<script>

import { defineComponent, reactive, onMounted, computed } from "vue";

export default defineComponent({
  props: {
    scope: {
      type: String,
      required: true
    },
    collection: {
      type: Object,
      required: true
    }
  },
  setup(props) {
    const state = reactive({
      currPage: 0,
      hasMore: true,
      username: '',
      is_authenticated: false,
      loading: false,
      itemsCols: 4,
      itemsRows: 2,
      itemsCount: 8,
      items: [],
    });

    const shouldShowNoMoreData = computed(() => {
      return !state.loading && !state.hasMore;
    });

    const getUsernameFromURL = () => {
      const url = window.location.href;
      const match = url.match(/\/p\/([^\/]+)\/collections/);
      return match ? match[1] : '';
    };

    const fetchItemData = async (page = state.currPage + 1, perPage = state.itemsCount) => {
      if (state.loading || !state.hasMore) return;

      state.loading = true;
      const url = `/api/v1/profiles/${state.username}/get_posts_by_ids`;
      const params = new URLSearchParams();
      props.collection.post_ids.forEach((id) => params.append('ids[]', id));
      params.append('page', page);
      params.append('per_page', perPage);

      try {
        const response = await fetch(`${url}?${params.toString()}`);
        if (!response.ok) throw new Error(`Error: ${response.status}`);
        const data = await response.json();

        if (page === 1) {
          state.items = [...data.data];
        } else {
          state.items = [...state.items, ...data.data];
        }

        state.currPage = data.pagination.current_page;
        state.hasMore = state.currPage < data.pagination.total_pages;

        if (page === 1 && data.data.length > 0 && window.trackingEvent) {
          window.trackingEvent.view_item_list({
            item_list_id: `creator_collection:${props.collection.id}`,
            item_list_name: 'creator_collection',
            item_list_index: 1,
            items: data.data.map((item, index) => ({
              id: item.id,
              title: item.title,
              creator: item.creator?.brand_name,
              price: item.price,
              index,
            })),
          });
        }

      } catch (error) {
        console.error("Error fetching items:", error);
        state.hasMore = false;
      } finally {
        state.loading = false;
      }
    };

    const handleScrollEvent = () => {
      const scrollableHeight = document.body.scrollHeight - window.innerHeight - 150;
      const scrolledDistance = Math.max(
        window.pageYOffset,
        document.documentElement.scrollTop,
        document.body.scrollTop
      );

      if (scrolledDistance >= scrollableHeight && state.hasMore && !state.loading) {
        fetchItemData();
      }
    };

    const setupItemColsCount = () => {
      if (window.innerWidth >= 1024) {
        state.itemsCols = 4;
      } else if (window.innerWidth >= 780) {
        state.itemsCols = 3;
      } else if (window.innerWidth >= 705) {
        state.itemsCols = 2;
      } else {
        state.itemsCols = 1;
      }
      state.itemsCount = state.itemsCols === 1 ? 10 : state.itemsCols * state.itemsRows;
    };

    onMounted(() => {
      state.username = getUsernameFromURL();
      setupItemColsCount();
      fetchItemData();
      window.addEventListener('scroll', handleScrollEvent);
    });

    return {
      state,
      shouldShowNoMoreData,
      fetchItemData,
      handleScrollEvent
    };
  }
})
</script>
